import React from "react";
import bewakoof from '../Doc/Product/bewakoof.png'
import justShop from '../Doc/Product/justShop.png'
import Dermstore from '../Doc/Product/dermstore.png'
import KFC from '../Doc/Product/Kfc.png'
import plu from '../Doc/Product/plu.png'
import Movie from '../Doc/Product/movie.png'
import Trip from '../Doc/Product/trip.png'
import TODO from '../Doc/Product/To_Do.png'
import "./Portfolio.css";
import { ImHtmlFive } from 'react-icons/im'
import { SiCss3, SiJavascript, SiPostman, SiGithub, SiHeroku, SiChakraui,SiExpress,SiMongodb } from 'react-icons/si'
import { FaReact } from 'react-icons/fa'
import { TbLivePhoto } from 'react-icons/tb'
import GraphicSlide from "../Slide/GraphicSlide";
export const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container portfolio__container">




      <article className="portfolio__item">
          <h3>JustShop.Com</h3>
          <div className="portfoli__item-image">
            <img src={justShop}></img>
          </div>

          <h5>
          It is individual project where we've used MERN stack to make the JustShop.com along with frontend and backend integration, fully responsive, smooth UI and Admin Side.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <FaReact /> </a>
            <a className="btn2"> <SiChakraui /> </a>
            <a className="btn2"> <ImHtmlFive /> </a>
            <a className="btn2"> <SiCss3 /> </a>
            <a className="btn2"> <SiJavascript /> </a>
            <a className="btn2"> <SiExpress /> </a>
            <a className="btn2"> <SiMongodb/> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/osamakhan9/JustShop"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://client-ashen-beta.vercel.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>

        {/* first project1 */}

        
        <article className="portfolio__item">
          <h3>WanderLust.Com</h3>
          <div className="portfoli__item-image">
            <img src={Trip}></img>
          </div>

          <h5>
          WanderLust is an E-Commerce website where we Easily find your perfect trip and book with flexibity and family travel. This project cloned during the construct week project 5 days with 5-members.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <FaReact /> </a>
            <a className="btn2"> <SiChakraui /> </a>
            <a className="btn2"> <ImHtmlFive /> </a>
            <a className="btn2"> <SiCss3 /> </a>
            <a className="btn2"> <SiJavascript /> </a>
            <a className="btn2"> <SiExpress /> </a>
            <a className="btn2"> <SiMongodb/> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/Lokesh777/prized-ring-1889.git"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://prized-ring-1889.netlify.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>

        {/* First Project */}

        <article className="portfolio__item">
          <h3>Bewakoof.Com</h3>
          <div className="portfoli__item-image">
            <img src={bewakoof}></img>
          </div>

          <h5>
            This is individual project Bewakoof.com. I have cloned this project 10 days.This is a E-commerce web site fully responsive, smooth UI & all feature clone.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <FaReact /> </a>
            <a className="btn2"> <SiChakraui /> </a>
            <a className="btn2"> <ImHtmlFive /> </a>
            <a className="btn2"> <SiCss3 /> </a>
            <a className="btn2"> <SiJavascript /> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/osamakhan9/Bewakoof.com-clone-"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://legendary-moonbeam-59c991.netlify.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>

          {/* Second project */}

        <article className="portfolio__item">
          <h3>Dermstore.Com</h3>
          <div className="portfoli__item-image">
            <img src={Dermstore}></img>
          </div>

          <h5>
          Dermstore is an E-Commerce website where we serve health care and beauty care products. This project cloned during the construct week project 5 days with 5.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <ImHtmlFive /> </a>
            <a className="btn2"> <SiCss3 /> </a>
            <a className="btn2"> <SiJavascript /> </a>
            <a className="btn2"> <FaReact /> </a>
            <a className="btn2"> <SiExpress /> </a>
            <a className="btn2"> <SiMongodb/> </a>
            <a className="btn2"><SiHeroku /> </a>
          </div> 
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/1Gireesh/Dermstore-full-stack-clone.git"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://celadon-piroshki-a9a67d.netlify.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>

       {/* Third Project */}

        <article className="portfolio__item">
          <h3>KFC.Com</h3>
          <div className="portfoli__item-image">
            <img src={KFC}></img>
          </div>

          <h5>
            KFC is the marketing industry's leading provider of content calendar, content optimization, and Food Delivery. This was a collaborative project buit by team of 5 members in 5 days.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <ImHtmlFive /> </a>
            <a className="btn2"> <SiCss3 /> </a>
            <a className="btn2"> <SiJavascript /> </a>
            <a className="btn2"> <SiPostman /> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/hemant097/KFC-clone.git"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://venerable-sprite-c3ed8d.netlify.app/homepage"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>


        {/* Four Projects */}

        <article className="portfolio__item">
          <h3>TO-DO LIST</h3>
          <div className="portfoli__item-image">
            <img src={TODO}></img>
          </div>

          <h5>
          It's my major project TO-DO LIST is an online List Add. implemented all the features of an Filter and Update and Delete and Alert, smooth UI, manage by smoothness Chakra-UI.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"> <ImHtmlFive /> </a>
            <a className="btn2"> <SiCss3 /> </a>
            <a className="btn2"> <SiJavascript /> </a>
            <a className="btn2"> <SiPostman /> </a>
            <a className="btn2"> <FaReact /> </a>
            <a className="btn2"> <SiChakraui /> </a>
            <a className="btn2"><SiHeroku /> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/osamakhan9/TODO-List"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://glittering-piroshki-f7a3fa.netlify.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>




        {/* five Project */}

        <article className="portfolio__item">
          <h3>Pluralsight.Com</h3>
          <div className="portfoli__item-image">
            <img src={plu}></img>

          </div>

          <h5>
            Pluralsight is India's largest online higher education company
            providing programs in Data Science, Technology, Management and coding. This was a collaborative project buit by team of 5 members in 5 days.
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"><ImHtmlFive /> </a>
            <a className="btn2"><SiCss3 /></a>
            <a className="btn2"><SiJavascript /></a>
            <a className="btn2"><SiPostman /></a>
            <a className="btn2"><SiHeroku /> </a>
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/hariohmtripathi/Pluralsight.git"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>

              Github <SiGithub />
            </a>
            <a
              href="https://classy-semolina-ace696.netlify.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >

              <span></span>
              <span></span>
              <span></span>
              <span></span>

              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>

       {/* Six Project */}

        <article className="portfolio__item">
          <h3>Movie Web Site</h3>
          <div className="portfoli__item-image">
            <img src={Movie}></img>

          </div>

          <h5>
          It's my major project Hotstart is an online Watch Movie. implemented all the features of an e-commerce website , Slide smooth, smooth UI
          </h5>

          <div className="portfolio__item-stack">
            <a className="btn2"><ImHtmlFive /> </a>
            <a className="btn2"><SiCss3 /></a>
            <a className="btn2"><SiJavascript /></a>
           
          </div>
          <div className="portfolio__item-cta">
            <a
              href="https://github.com/osamakhan9/Movie-Site-Clone-"
              target="_blank"
              className="btn"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Github <SiGithub />
            </a>
            <a
              href="https://splendid-creponne-e9a1c5.netlify.app/"
              target="_blank"
              className="btn btn-primary"
              id='btn_animation'
            >
              <span></span><span></span><span></span><span></span>
              Live Demo <TbLivePhoto />
            </a>
          </div>
        </article>

      </div>

     <div id="Graphic">
     <GraphicSlide />
     </div>

    </section>
  );
};
